// extracted by mini-css-extract-plugin
export default {"header":"Roles_header__ScdEM","title":"Roles_title__4eooL","formContainer":"Roles_formContainer__5jn8Y","createAccountInputField":"Roles_createAccountInputField__1OzUh"};